"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _styles = require("@material-ui/core/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _greyscale = _interopRequireDefault(require("../../theme/colors/greyscale"));
var _typography = _interopRequireDefault(require("../../theme/typography"));
var _excluded = ["classes", "dataMetrics"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    popper: {
      opacity: 1
    },
    tooltip: {
      background: _greyscale["default"][800],
      borderRadius: '2px',
      color: _greyscale["default"].white,
      fontFamily: _typography["default"].caption.fontFamily,
      fontSize: _typography["default"].caption.fontSize,
      fontWeight: _typography["default"].caption.fontWeight,
      lineHeight: _typography["default"].caption.lineHeight,
      maxWidth: '336px'
    },
    tooltipHorizontal: {
      margin: '0 8px'
    },
    tooltipVertical: {
      margin: '8px 0'
    }
  };
});
var defaultProps = {
  dataMetrics: {
    root: 'fuse_tooltip'
  },
  placement: 'bottom'
};

/**
 * Tooltips display informative text when user hover over, focus on, or tap an element.
 * Tooltips appear in the center of click targets and stay in place while cursor moves within the target. Consider using the [`Popper`](#/Components/Popper/) Component as it has similar functionality.
 */
var Tooltip = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var classes = props.classes,
    dataMetrics = props.dataMetrics,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var localClasses = useStyles();
  var mergedClasses = _objectSpread({}, localClasses, {}, classes);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], (0, _extends2["default"])({
    classes: _objectSpread({
      popper: mergedClasses.popper,
      tooltip: mergedClasses.tooltip,
      tooltipPlacementBottom: mergedClasses.tooltipVertical,
      tooltipPlacementLeft: mergedClasses.tooltipHorizontal,
      tooltipPlacementRight: mergedClasses.tooltipHorizontal,
      tooltipPlacementTop: mergedClasses.tooltipVertical
    }, classes),
    PopperProps: {
      'data-metrics': mergedDataMetrics.root
    },
    ref: ref
  }, rest));
});
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Tooltip reference element.
   */
  children: _propTypes["default"].element.isRequired,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/tooltip/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * Do not respond to focus events.
   */
  disableFocusListener: _propTypes["default"].bool,
  /**
   * Do not respond to hover events.
   */
  disableHoverListener: _propTypes["default"].bool,
  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: _propTypes["default"].bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This property won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: _propTypes["default"].number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: _propTypes["default"].number,
  /**
   * The relationship between the tooltip and the wrapper component is not clear from the DOM.
   * This property is used with aria-describedby to solve the accessibility issue.
   * If you don't provide this property. It falls back to a randomly generated id.
   */
  id: _propTypes["default"].string,
  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: _propTypes["default"].bool,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This property won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: _propTypes["default"].number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: _propTypes["default"].number,
  /**
   * Callback fired when the tooltip requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: _propTypes["default"].func,
  /**
   * Callback fired when the tooltip requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: _propTypes["default"].func,
  /**
   * If `true`, the tooltip is shown.
   */
  open: _propTypes["default"].bool,
  /**
   * Tooltip placement.
   */
  placement: _propTypes["default"].oneOf(['bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end', 'top', 'top-start', 'top-end']),
  /**
   * Properties applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: _propTypes["default"].object,
  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: _propTypes["default"].node.isRequired,
  /**
   * Transition component.
   */
  TransitionComponent: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * Properties applied to the `Transition` element.
   */
  TransitionProps: _propTypes["default"].object
  // transition style defined? if so, which one to use?  customizable?  current default is 'grow'
  // delays
} : {};
var _default = Tooltip;
exports["default"] = _default;